import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,reorderArray } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import {Storage} from "@ionic/storage";
import { AddarticoloPage } from '../addarticolo/addarticolo';
import { EditarticoloPage } from '../editarticolo/editarticolo';
import { EditcategoriaPage } from '../editcategoria/editcategoria';
import { SERVER_URL } from "../../config";

/**
 * Generated class for the ArticoliPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-articoli',
  templateUrl: 'articoli.html',
})
export class ArticoliPage {
  articoli: string[];
  errorMessage: string;
  categoriaItem;
  link;
  constructor(public navCtrl: NavController, public navParams: NavParams,
               public rest: RestApiProvider,
               private readonly storage: Storage,

  ) {
    this.categoriaItem=navParams.get('categoria');
    this.link = SERVER_URL + "/manifesti/files/"

  }
  getArticoli() {
    console.log('categoriaItem :'+this.categoriaItem);

    this.rest.getArticoli(this.categoriaItem)
       .subscribe(
         articoli => this.articoli = articoli,
         error =>  this.errorMessage = <any>error);
      
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ArticoliPage');
    console.log('Artilicoli LISTTTTTTTTTTTTTTTTTTTTTTT :'+this.getArticoli());

    
    console.log('articoli:'+this.articoli);

  }
  reorderItems(indexes){
    console.log("reorderItems:" + JSON.stringify(indexes));

    this.articoli = reorderArray(this.articoli, indexes);


    console.log("reorderItems list:" + JSON.stringify(this.articoli));
    var i = 0;
    this.articoli.forEach(function (element) {

      console.log(element["name"]);
      element["visibilita"] = i;
      i++;
    });
    console.log("reorderItems list durante:" + JSON.stringify(this.articoli));



    this.rest.aggiornaListArticoli(this.articoli);

}
openAddarticoloPage() {

  this.navCtrl.push(AddarticoloPage,{categoria:this.categoriaItem});

}
openEditarticoloPage(articolo) {

  this.navCtrl.push(EditarticoloPage,{articolo:articolo});
 

}
openEditcategoriaPage(){
  this.navCtrl.push(EditcategoriaPage, { categoria: this.categoriaItem });

}
}



// WEBPACK FOOTER //
// ./src/pages/articoli/articoli.ts